export const environment = {
  production: true,
  cdnBaseUrl: "https://stage-cdn.ischoolconnect.com",
  landingPageUrl: "https://landing-stage.ischoolconnect.com",
  apiUrl: "https://via-stage-api-uc.ischoolconnect.com",
  studentLogrocketId: "comozl/student-dashboard-stage-b6wdv",
  advisorLogrocketId: "comozl/advisor-dashboard-stage-pcxny",
  advisorBackendUrl: "https://stage-2-advisor-api.ischoolconnect.com"
};
